<template>
  <div class="al-root">

    <!-- Header -->
    <header class="al-header">
      <RouterLink to="/" class="al-logo">
        <img src="/new-logo.png" class="al-logo-mark" alt="">
        <span class="al-logo-text">Maths Eleven Plus</span>
      </RouterLink>
    </header>

    <!-- Card -->
    <main class="al-main">
      <div class="al-card">
        <RouterView />
      </div>
    </main>

    <!-- Trust strip -->
    <footer class="al-footer">
      <span>🔒 Secure &amp; private</span>
      <span>🇬🇧 UK curriculum aligned</span>
    </footer>

  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,500;1,600&family=Jost:wght@300;400;500;600;700&display=swap');

.al-root {
  min-height: 100vh;
  background: #0D1628;
  display: flex;
  flex-direction: column;
  font-family: 'Jost', sans-serif;
  background-image:
    radial-gradient(circle at 70% 30%, rgba(184,144,42,0.06) 0%, transparent 50%),
    url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23B8902A' fill-opacity='0.02'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/svg%3E");
}

.al-header {
  display: flex;
  justify-content: center;
  padding: 32px 24px 20px;
}

.al-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.al-logo-mark {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
}

.al-logo-text {
  font-family: 'Cormorant Garamond', serif;
  font-size: 22px;
  font-weight: 600;
  color: white;
  letter-spacing: 0.02em;
}

.al-main {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12px 24px 40px;
}

.al-card {
  width: 100%;
  max-width: 440px;
  background: #F9F6EF;
  border-radius: 8px;
  padding: 44px 44px 40px;
  box-shadow: 0 40px 80px rgba(0,0,0,0.4), 0 0 0 1px rgba(184,144,42,0.15);
}

.al-footer {
  display: flex;
  justify-content: center;
  gap: 32px;
  padding: 20px 24px 28px;
  font-size: 12px;
  color: rgba(255,255,255,0.7);
  font-family: 'Jost', sans-serif;
  flex-wrap: wrap;
}

@media (max-width: 480px) {
  .al-card { padding: 32px 28px; }
  .al-footer { gap: 16px; }
}
</style>
